import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "sonner";
import z from "zod";
import { useChannelContext } from "~/contexts/channel";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";
import { Field, FieldError, FieldLabel } from "./ui/field";
import { Input } from "./ui/input";

const formSchema = z.object({
  channelCode: z.string().min(1, "Channel code is required"),
});

export const ChangeChannelCode = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { code, onChangeCode } = useChannelContext();

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: { channelCode: code },
  });

  async function onSubmit(data: z.infer<typeof formSchema>) {
    console.log("Updating channel code to:", data.channelCode);
    await onChangeCode(data.channelCode);
    toast.success("Channel code updated successfully");
    setIsOpen(false);
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <button className="ekv:cursor-pointer ekv:text-sm ekv:text-muted-foreground ekv:hover:underline">
          Change Channel Code
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Change Channel Code</DialogTitle>
          <DialogDescription>
            Enter a new channel code to switch channels.
          </DialogDescription>
        </DialogHeader>
        <form
          id="update-channel-code-form"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <Controller
            control={form.control}
            name="channelCode"
            render={({ field, fieldState }) => (
              <Field aria-invalid={fieldState.invalid}>
                <FieldLabel htmlFor={field.name}>Channel Code:</FieldLabel>
                <Input
                  {...field}
                  id={field.name}
                  aria-invalid={fieldState.invalid}
                />
                {fieldState.error && <FieldError errors={[fieldState.error]} />}
              </Field>
            )}
          />
        </form>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button
            type="submit"
            form="update-channel-code-form"
            disabled={form.formState.isSubmitting}
          >
            Save changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
